export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7436.3b2b7389.jpg";